var _style, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgContributionStep4 = function SvgContributionStep4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "contribution-step-4_svg__\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 32 40",
    style: {
      enableBackground: "new 0 0 32 40"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".contribution-step-4_svg__st2{fill:#be1d32}")), /*#__PURE__*/React.createElement("g", {
    id: "contribution-step-4_svg__\\u7EC4_5638",
    transform: "translate(-881.711 -141.422)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "contribution-step-4_svg__\\u8DEF\\u5F84_15839",
    d: "m907.5 179-22-17.6 22-17.6 2.5 3.1-18 14.4 18 14.4-2.5 3.3z",
    style: {
      fill: "#e8eaf1"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "contribution-step-4_svg__\\u692D\\u5706_1283",
    cx: 889.7,
    cy: 161.4,
    r: 8,
    style: {
      fill: "#172d72"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "contribution-step-4_svg__\\u692D\\u5706_1284",
    className: "contribution-step-4_svg__st2",
    cx: 907.6,
    cy: 147.4,
    r: 6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "contribution-step-4_svg__\\u692D\\u5706_1285",
    className: "contribution-step-4_svg__st2",
    cx: 907.7,
    cy: 175.4,
    r: 6
  }))));
};
export default SvgContributionStep4;